import { $$user } from '../../../../services/UserService/UserService';
import { createManageUsersTabModel } from '../../../../components/AdminUsersPage/ManageUsersTab/createManageUsersTabModel.ts';

export const $$ghsAdminManageUsersTab = createManageUsersTabModel({
  getUsersFx: $$user.adminGetUsersFx
});